export const STAFF_URL_REDIRECT_STATUS = 301 as const;

export function contactsListRedirect() {
  return {
    to: "/students" as const,
    search: { stage: "lead" as const },
    statusCode: STAFF_URL_REDIRECT_STATUS,
  };
}

export function contactsDetailRedirect(contactId: string) {
  return {
    to: "/students/$studentId" as const,
    params: { studentId: contactId },
    statusCode: STAFF_URL_REDIRECT_STATUS,
  };
}

export function classTasksRedirect() {
  return {
    to: "/class-sessions" as const,
    statusCode: STAFF_URL_REDIRECT_STATUS,
  };
}

export function salesDashboardRedirect() {
  return {
    to: "/orders" as const,
    statusCode: STAFF_URL_REDIRECT_STATUS,
  };
}

export function deliveryIndexRedirect() {
  return {
    to: "/delivery/sites" as const,
    statusCode: STAFF_URL_REDIRECT_STATUS,
  };
}
